module.exports = __webpack_public_path__ + "static/media/bg3.6e771a1e.png";